import {
  cn,
  Spacer,
  Ripple,
  useRipple,
  Image,
  Accordion,
  AccordionItem,
} from "@heroui/react";
import { useLogout, useMenu, useTranslate } from "@refinedev/core";
import { TreeMenuItem } from "@refinedev/core/dist/hooks/menu/useMenu";
import {
  IconLogout,
} from "@tabler/icons-react";
import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useActiveAssociation } from "../../context/active-association.context";
import { useSidebar } from "../../hooks";
import {getDeviceId} from "../../utils/deviceId";
import {getVersionString} from "../../utils/version";
import {TraceInformation} from "../layout/tracing";

export const Sidebar: React.FC = () => {
  const activeAssociation = useActiveAssociation();
  const { menuItems, selectedKey } = useMenu({
    meta: {
      associationId: activeAssociation?.id,
    },
  }); // Utilize Refine's headless core
  const translate = useTranslate();

  const { isOpen, setIsOpen } = useSidebar();

  const { mutate: logout } = useLogout();
  useEffect(() => {
    setIsOpen(false);
  }, [selectedKey]);

  return (
    <>
      <aside
        id="default-sidebar"
        className={cn(
          "fixed top-0 left-0 z-30 w-full  transition-transform h-full",
          isOpen ? "translate-y-0" : "-translate-y-full"
        )}
        aria-label="Sidebar"
      >
        <div className="flex flex-col items-center justify-center h-full px-3 py-4 overflow-y-auto bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))]  from-primary via-primary-shade to-primary dark:bg-gray-800">
          <div className={"justify-center my-5 h-36 "}>
            <Image
              src={`${
                import.meta.env.VITE_PUBLIC_BACKEND_API_BASE_URL
              }/cpg-logo.png`}
              className={"object-cover h-36 "}
            />
          </div>
          <div
            aria-label="Sidebar"
            className={"mt-10 flex flex-col max-w-sm justify-center w-full"}
          >
            {menuItems.map((treeItem, index) => (
              // <SidebarLink treeItem={treeItem} />
              // <Link to={treeItem.route} key={treeItem.key} as={NavLink}>
              //   {treeItem.meta?.label}
              (<TreeItem treeItem={treeItem} key={index} />)
            ))}
            <div
              className={
                "hover:text-light hover:bg-secondary rounded-2xl flex my-1 py-4 px-8 mx-4 flex text-danger cursor-pointer"
              }
              onClick={() => {
                logout();
                setIsOpen(false);
              }}
            >
              <IconLogout className={"mr-2"} />
              Logout
            </div>
          </div>
          <TraceInformation/>
        </div>
      </aside>
    </>
  );
};

type SidebarTreeItemProps = {
  treeItem: TreeMenuItem;
};
export const TreeItem: React.FC<SidebarTreeItemProps> = ({ treeItem }) => {
  return (
    <>
      {treeItem.children && treeItem.children.length > 0 ? (
        <TreeItemAccordion treeItem={treeItem} />
      ) : (
        <TreeItemLink treeItem={treeItem} />
      )}
    </>
  );
};

const TreeItemLink = ({ treeItem }: { treeItem: TreeMenuItem }) => {
  const rippleProps = useRipple({});
  const { selectedKey } = useMenu();
  return (
    <NavLink
      to={treeItem.route!}
      key={treeItem.key}
      className={({ isActive, isPending }) => {
        const base = `hover:text-light hover:bg-secondary  rounded-2xl flex my-1 py-4 px-8`;
        const layout = treeItem.meta?.parent ? "mx-4" : "mx-4";

        if (selectedKey === treeItem.key) {
          return cn(base, layout, "bg-light text-dark");
        }
        return cn(base, layout, "rounded-2xl text-light");
      }}
    >
      <Ripple {...rippleProps} />
      {treeItem.meta?.icon && (
        <>
          {treeItem.meta?.icon}
          <Spacer x={1.5} />
        </>
      )}
      {treeItem.meta?.label}
    </NavLink>
  );
};

const TreeItemAccordion = ({ treeItem }: { treeItem: TreeMenuItem }) => {
  return (
    <Accordion
      isCompact={false}
      className={"text-light rounded-2xl mx-4 px-0 flex w-auto"}
      itemClasses={{
        base: "w-full",
        title: "font-normal text-medium text-light",
        trigger: "px-8 rounded-2xl hover:bg-secondary flex w-full",
        indicator: "",
        content: "w-full",
        titleWrapper: "bg-none data-[hover=true]:text-secondary w-full",
      }}
    >
      <AccordionItem
        key={treeItem.key}
        title={treeItem?.meta?.label}
        startContent={treeItem?.meta?.icon}
      >
        {treeItem.children?.map((el) => (
          // <TreeItem key={`treeItem_${el.key}`} treeItem={el} />
          (<div key={`span_${el.key}`}>
            <TreeItemLink treeItem={el} />
          </div>)
        ))}
      </AccordionItem>
    </Accordion>
  );
};
